import { all, call, put, takeLatest, fork, take, takeEvery } from 'redux-saga/effects'
import { messageTypes } from './messages.types'
import io from 'socket.io-client'
import { eventChannel } from 'redux-saga'
import { setFeedbackboxValues, setRemoveMessageByTmpId } from './messages.actions'
// import * as Sentry from '@sentry/react'

import {
  setNewMessage,
  setAcceptedChat,
  setFetchMoreMessages,
  setOldMessages,
  setDisableInput,
  updateAcceptedChatAvatar,
  setCurrentUser,
  setSocketConnectionError,
  setDefaultOnlineAgent,
  setDepartments,
  removeAcceptedChat,
  setEditedMessage,
  setSeenStatusForAllMessages,
  removeConversationNotSeenStart,
  setMessageId,
  setReplyingMessage,
  setSubmitedFormStatus,
  setHideChatInputForTeams,
  setShowGreetingInput,
  setNotSeenReceivedMsgs,
  incrementNotSeenReceivedMsgs,
  setUploadProgressData,
  setConfirmUploadedData,
  setUploadError,
  setSentCloseButton,
} from './messages.actions'
import { select } from 'redux-saga/effects'
import {
  appLocalStorageObject,
  checkForVisitorDetails,
  checkForNewVisitor,
  sendNewMessage,
  createOperatorMessage,
  createAcceptedStatusMessage,
  createClosedStatusMessage,
  getAcceptedChatInfo,
  createTriggerMessage,
  getFileData,
  createFileMessage,
  uploadFile,
  sendNewWord,
  fetchMessages,
  // addNewComment,
  handleRemoveNotSeenConversation,
  createGroupMessage,
  submitDynamicUserFormData,
  isThereAnyUnfilledFieldInForm,
  handleTalkWithOperator,
  sendMedia,
  getUploadFileError,
  submitFeedbackToServer,
  handleSendSentCloseButtonAction,
} from './messages.adapter'
import { setActiveTriggerMessage, setForms, setShowTrigger, setWidgetReady } from '../widget/widget.actions'
import { setMessageStatus, removeFormMessage } from './messages.actions'
import { setShowWidget } from '../widget/widget.actions'
import { fetchWidgetInfo } from '../widget/widget.sagas'
import { triggerEvent } from 'app/utils/event'
import { SOCKET_URL } from '../../utils/urls'
import { LAUNCHER_CONTENT_STATE, MESSENGER_TAB_STATE } from 'app/constants/launcherContentStates'
import { playNotifSound } from 'app/utils/sound'
import { ON_MSG_RECEIVED_FROM_OPERATOR, ON_USER_SENT_MSG } from 'app/constants/events'
import {
  ON_CHAT_STARTED_BY_OPERATOR,
  ON_CONNECTION_ESTABLISHED,
  ON_CONVERSATION_ACCEPTED,
  ON_CONVERSATION_CLOSED,
  ON_MESSAGE_BROADCASTED,
  ON_MESSAGE_SEEN_BY_OPERATOR,
  ON_NEW_MESSAGE_RECEIVED,
  ON_OPERATOR_EDITED_MSG,
  ON_SOCKET_CONNECTION_ERROR,
  ON_SOCKET_CONNECTION_FAILED,
  ON_SOCKET_DISCONNECTED,
  ON_USER_IS_BANNED,
  ON_SENT_CLOSE_BUTTON,
} from 'app/constants/socketEvents'
import { getHostWebsiteUrl } from 'app/utils/links'

const getWidgetInfo = (state) => {
  return {
    container_id: state.widgetData.widgetInfo.data.channel.containerId,
    channel_id: state.widgetData.widgetInfo.data.channel.id,
    widget_info: state.widgetData.widgetInfo.data,
    activeDepartment: state.messagesData.activeDepartment.data,
    isOfficeHour: state.widgetData.widgetInfo.isOfficeHour,
    forms: state.widgetData.widgetInfo.data.forms,
    showLauncher: state.widgetData.widgetInfo.showLauncher,
    acceptedChat: state.messagesData.acceptedChat,
    languageInfo: state.widgetData.widgetInfo.languageInfo,
    launcherState: state.widgetData.widgetInfo.launcherInfo.content,
    user: state.messagesData.user,
    currentTab: state.widgetData.widgetInfo.currentTab,
    messengerTabState: state.widgetData.widgetInfo.messengerTabState,
    departments: state.messagesData.departments.data,
    defaultTeam: state.messagesData.defaultTeam,
  }
}

const getUserTypingWordsStatus = ({ widgetData }) =>
  widgetData.widgetInfo.data.publicSetting.operatorCanSeeUserTypingWordsEnabled
const getChannelToken = ({ widgetData }) => widgetData.widgetInfo.data.channel.token
const getOperators = ({ widgetData }) => widgetData.widgetInfo.data.operators
const getUploadFileInfo = (state) => {
  return {
    activeDepartment: state.messagesData.activeDepartment.data,
    replyingMessage: state.messagesData.replyingMessage,
  }
}
const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts
const getPackageIndex = ({ widgetData }) => widgetData.widgetInfo.data.channel.package.index

function groupBy(array, property) {
  return array.reduce((result, currentItem) => {
    const key = currentItem[property]
    if (!result[key]) {
      result[key] = []
    }
    result[key].push(currentItem)
    return result
  }, {})
}

var socket
var widgetInfo
var containerId
var channelId
var userIdForSpa

function* connect() {
  const socket = io(SOCKET_URL, {
    reconnectionDelayMax: 10000,
    transports: ['websocket'],
    path: '/socket.io',
    query: {
      type: 'widget',
      token: window.parent.RAYCHAT_TOKEN,
      url: getHostWebsiteUrl(),
      ref: document.referrer,
    },
    autoConnect: true,
  })

  return yield new Promise((resolve) => {
    socket.on(ON_CONNECTION_ESTABLISHED, () => {
      resolve(socket)
    })
  })
}

function subscribe({ socket, texts, acceptedChat, operators }) {
  return eventChannel((emit) => {
    socket.on(ON_CONNECTION_ESTABLISHED, () => {
      checkForVisitorDetails(socket, channelId, containerId)
      emit(
        setSocketConnectionError({
          status: false,
          description: '',
        }),
      )
    })
    socket.on(ON_SOCKET_CONNECTION_ERROR, () => {
      emit(
        setSocketConnectionError({
          status: true,
          description: texts.disconnectedFromServer,
        }),
      )
    })
    socket.on(ON_SOCKET_CONNECTION_FAILED, () => {
      emit(
        setSocketConnectionError({
          status: true,
          description: texts.disconnectedFromServer,
        }),
      )
    })
    socket.on(ON_SOCKET_DISCONNECTED, () => {
      emit(
        setSocketConnectionError({
          status: true,
          description: texts.disconnectedFromServer,
        }),
      )
    })

    /**
     * acceptedChat method response
     * @typedef {{
     *  avatar: string
     *  conversationId: string,
     *  id: string,
     *  lname: string,
     *  name: string,
     *  teamId: string
     *  title: string
     * }} acceptedChatRes - id here is operatorId
     *
     * it will be called when one operator transfers a conversation to himself/herself
     *
     * @param  {acceptedChatRes} res
     */
    socket.on(ON_CONVERSATION_ACCEPTED, (res) => {
      const { teamId } = res

      const operator = operators?.find((op) => op.id === res.id)
      const avatar = operator?.avatar

      // Do not show status message when conversation is started from the operator and show greeting window instead
      if (res.startedChatFromAgent) {
        emit(setShowTrigger(true))
      } else {
        emit(
          // operator acccepted message
          setNewMessage({
            message: createAcceptedStatusMessage(operator),
            teamId,
          }),
        )
      }

      acceptedChat = getAcceptedChatInfo({ ...res, avatar })

      emit(setAcceptedChat(acceptedChat))
    })

    socket.on(ON_CHAT_STARTED_BY_OPERATOR, (res) => {
      acceptedChat = getAcceptedChatInfo(res)

      emit(setAcceptedChat(acceptedChat))

      emit(setShowTrigger(true))
    })

    socket.on(ON_CONVERSATION_CLOSED, (res) => {
      const { teamId, conversationId, agentId } = res

      // conversation closed status message
      emit(
        setNewMessage({
          message: createClosedStatusMessage(),
          teamId,
        }),
      )

      // remove accepeted chat
      emit(removeAcceptedChat(teamId))
      // if (acceptedChat.status) {

      // build comment message
      emit(
        setNewMessage({
          message: {
            me: false,
            type: 'feedback',
            rate: null,
            comment: '',
            formStatus: null,
            agentId,
            conversationId,
            teamId,
          },
          teamId,
        }),
      )
      // }
    })

    socket.on(ON_USER_IS_BANNED, () => {
      emit(setShowWidget(false))
      socket.disconnect()
    })

    socket.on(ON_MESSAGE_BROADCASTED, (res) => {
      emit(
        setNewMessage({
          message: createGroupMessage(res.message),
        }),
      )
    })

    socket.on(ON_NEW_MESSAGE_RECEIVED, (res) => {
      if (res.messageObj || res.message) {
        const teamId = res.teamId
        const message = createOperatorMessage(res)
        const operator = operators.find((item) => item.id === res.agent_id)
        emit(
          setNewMessage({
            message,
            teamId,
          }),
        )
        emit(setActiveTriggerMessage(createTriggerMessage(res, operator)))
        emit(setShowTrigger(true))
        emit(
          updateAcceptedChatAvatar({
            avatar: res.agent_avatar,
            isBot: res.isBot,
            teamId: res.teamId,
          }),
        )
        playNotifSound('MSG_RECEIVED')

        // TODO: check if the conversation is open then send request.

        emit(
          removeConversationNotSeenStart({
            conversationId: res.conversationId,
            checkIsInChat: true,
          }),
        )

        triggerEvent(ON_MSG_RECEIVED_FROM_OPERATOR, {
          type: message.type,
          content: message.content,
        })
      }
    })

    socket.on(ON_SENT_CLOSE_BUTTON, (res) => {
      emit(
        setSentCloseButton({
          data: {
            value: true,
            by: res.by,
            agentInfo: {
              name: res.agentInfo?.name,
              avatar: res.agentInfo?.avatar,
            },
          },
          teamId: res.teamId,
        }),
      )
    })

    // fired when operator edited a message
    socket.on(ON_OPERATOR_EDITED_MSG, (res) => {
      emit(
        setEditedMessage({
          message: res.message,
          messageId: res.messageId,
        }),
      )
    })

    // TODO: complete it
    socket.on(ON_MESSAGE_SEEN_BY_OPERATOR, (res) => {
      emit(
        setSeenStatusForAllMessages({
          conversationId: res.conversationId,
          teamId: res.teamId,
        }),
      )
    })

    return () => {}
  })
}

function* read(socket) {
  // message texts
  const { languageInfo, acceptedChat } = yield select(getWidgetInfo)
  const operators = yield select(getOperators)

  const { texts } = languageInfo
  const channel = yield call(subscribe, {
    socket,
    texts,
    acceptedChat,
    operators,
  })
  while (true) {
    let action = yield take(channel)
    yield put(action)
  }
}

function* sendTextMessage({ payload }) {
  const channelToken = yield select(getChannelToken)
  const { teamId, message } = payload

  // dispatched when robot option is selected. means that message should not get sent to the server and should only displayed in the widget
  if (message.notSendToServer) return

  // TODO: check for missing props and sync with backend: moreData,conversationId,type
  const response = yield call(sendNewMessage, {
    socket,
    content: message.content,
    replyId: message.replyId,
    tmpId: message.tmpId,
    teamId,
    channelToken,
  })

  // SENT
  if (response.tmpId && response.status !== 2) {
    // check for showing forms after first message is sent
    let t = { status: 'sent', message_id: response.tmpId, team_id: teamId }
    yield put(setMessageStatus(t))
    // check for sending form action after sending message successfully
    yield takeFormsAction(false)

    // send message info to event listener
    triggerEvent(ON_USER_SENT_MSG, {
      type: 'text',
      content: message.content,
    })
  }

  if (response.status === 400 && response.message === 'required form fields') {
    yield takeFormsAction(false)
  }

  yield put(
    setMessageId({
      prevId: response.tmpId,
      newId: response?.chat?.id,
      teamId,
    }),
  )
  yield put(setReplyingMessage(null))
  yield put(setSentCloseButton({ data: { value: false }, teamId }))
}

// COMMENT-ALI : This function checks and verifies validity of file. rejects when invalid and sends when valid.
function* sendFileMessage({ payload }) {
  const { languageInfo } = yield select(getWidgetInfo)
  const packageIndex = yield select(getPackageIndex)
  const { activeDepartment, replyingMessage } = yield select(getUploadFileInfo)

  let file = payload

  const errorMsg = getUploadFileError({
    languageInfo,
    fileType: file.type,
    packageIndex,
    fileSize: file.size,
  })

  if (errorMsg) {
    yield put(setUploadError(errorMsg))
    return
  }

  const fileMessage = getFileData(file)

  const fileObj = {
    ...fileMessage, // fileMessage
    teamId: activeDepartment,
    replyId: replyingMessage?.id,
  }

  yield put(setConfirmUploadedData(fileObj))
  // yield put(getUploadFileActionObj(fileObj))
}

function* watchOnProgress(chan, fileMessage, teamId) {
  while (true) {
    const data = yield take(chan) // data is a number (percentage number)
    if (data === 100) return
    const t = {
      status: 'pending',
      progress: data === -1 ? null : data,
      message_id: fileMessage.tmpId,
      team_id: teamId,
    }
    yield put(setMessageStatus(t))

    yield put(
      setUploadProgressData({
        percentage: data === -1 ? null : data,
        fileType: fileMessage.type,
      }),
    )
  }
}

function* uploadFileMessage(payload) {
  let { widget_info, languageInfo } = yield select(getWidgetInfo)
  let { file, fileType, fileData, teamId, replyId } = payload

  if (payload) {
    const fileMessage = createFileMessage(payload)
    const msgObj = {
      message: {
        ...fileMessage,
        createdAt: new Date(),
      },
      teamId,
    }
    if (replyId) msgObj.message['replyId'] = replyId
    // update UI --> should remove this tmp message in case of error or user cancellation.
    yield put(setNewMessage(msgObj)) // POSSIBLE-FIX-ALI : What if the upload has failed?

    // clear replying message --> TODO-ALI-DONE : this should be done after user confirms the uploaded file.
    // yield put(setReplyingMessage(null)); // POSSIBLE-FIX-ALI : What if the upload has failed?

    const [uploadPromise, channel] = uploadFile(
      file,
      fileType,
      fileData,
      fileMessage.tmpId,
      socket,
      widget_info.channel.token,
      teamId,
      replyId,
      languageInfo,
    )
    // This is the watcher-saga for 'upload progress' in a seperate process
    yield fork(watchOnProgress, channel, fileMessage, teamId)
    try {
      const response = yield new Promise((resolve, reject) => {
        uploadPromise()
          .then((data) => {
            resolve(data)
          })
          .catch((error) => {
            // Mainly used to show upload errors in the new UI
            if (error.type === 'MANUAL_REJECT_UPLOAD_ERROR') {
              // This type is user for upload errors
              reject(error)
            }
          })
      })

      if (response?.responseId) {
        // yield put(setConfirmUploadedData(response))
        return response
      }
    } catch (e) {
      if (e.type === 'MANUAL_REJECT_UPLOAD_ERROR') {
        // This type is user for upload errors
        yield put(setUploadError(e.errMessage))
        // Remove message from messages list in store
        yield put(setRemoveMessageByTmpId({ tmpId: e.tmpId, teamId: e.teamId }))
      }
    }
  }
}

function* sendDynamicFormMessage({ payload }) {
  const { data } = payload

  const response = data.notSendToServer ? { success: true } : yield submitDynamicUserFormData(socket, data)

  const status = response.success ? 'filled' : 'failed'

  yield put(setSubmitedFormStatus({ formId: data.formId, status, teamId: data.teamId }))

  if (response.success) {
    yield put(
      setDisableInput({
        status: false,
        description: '',
      }),
    )

    // making greeting input usable if user has submited forced form
    yield put(setShowGreetingInput(true))

    yield put(removeFormMessage(data.teamId, data.formId))
  }
}

function* sendNewTypedWord({ payload }) {
  let { acceptedChat, activeDepartment, channel_id: channelId } = yield select(getWidgetInfo)
  const userTypingWordsEnabled = yield select(getUserTypingWordsStatus)
  const message = payload
  const chatInfo = acceptedChat[activeDepartment]

  if (!userTypingWordsEnabled || !chatInfo) return

  const operatorId = chatInfo.agentInfo?.id
  const conversationId = chatInfo.agentInfo?.conversationId

  sendNewWord(socket, { message, operatorId, channelId, conversationId })
}

function* fetchMoreMessages({ payload }) {
  const { page, teamId } = payload

  const response = yield new Promise((resolve) => {
    fetchMessages(socket, payload).then((data) => {
      resolve(data)
    })
  })

  // response.status = "sent"

  if (response.length > 0) {
    // set newly fetched messages
    yield put(setOldMessages({ messages: response, teamId }))
    // TODO: set seen messages status
    yield put(
      setFetchMoreMessages({
        allFetched: false,
        page: page + 1,
        teamId,
      }),
    )
  } else {
    yield put(
      setFetchMoreMessages({
        allFetched: true,
        teamId,
      }),
    )
  }
}

function* submitFeedback({ payload }) {
  let status

  const { rate, comment, agentId, conversationId, teamId, setLoadingSubmit } = payload
  try {
    const response = yield call(submitFeedbackToServer, {
      socket,
      data: {
        rate,
        comment,
        agentId,
        conversationId,
        teamId,
      },
    })

    status = response ? 'success' : 'failed'
  } catch (error) {
    status = 'failed'
  } finally {
    yield put(
      setFeedbackboxValues({
        teamId,
        conversationId,
        formStatus: status,
      }),
    )

    setLoadingSubmit(false)
  }
}

function* removeConversationNotSeen({ payload }) {
  const { conversationId, checkIsInChat } = payload
  const { launcherState, currentTab, messengerTabState, showLauncher, activeDepartment, departments } =
    yield select(getWidgetInfo)

  const selectedDepartment = departments?.filter((department) => department?._id === activeDepartment)[0]

  // filter agent all messages
  const agentMessage = selectedDepartment?.messages.find((msg) => !!msg.conversationId) || []

  const acceptedConversationId = selectedDepartment?.messages[0]?.conversationId || agentMessage?.conversationId

  // check if user is in the chat page
  if (checkIsInChat) {
    if (
      showLauncher &&
      acceptedConversationId === conversationId &&
      (launcherState === LAUNCHER_CONTENT_STATE.FIRST_CHAT ||
        (currentTab === 1 && messengerTabState === MESSENGER_TAB_STATE.CHAT))
    ) {
      yield call(handleRemoveNotSeenConversation, socket, conversationId)
    }

    return
  }

  yield call(handleRemoveNotSeenConversation, socket, conversationId)
}
/* 
manually  disconnect and connect socket with changed query params to record data. it is used when user navigates in spa apps.
in other forms of navigation this recording is done automatically from server side. */
function* recordRoadmapCheckpoints({ payload }) {
  const { previousUrl, currentUrl } = payload

  yield socket.disconnect()

  // change url parameters as user navigates in a spa app
  socket.io.opts.query = {
    ...socket.io.opts.query,
    url: currentUrl,
    ref: previousUrl,
    userId: userIdForSpa,
    isSpa: true,
  }

  yield socket.connect()
}

// checks messeages and increments according to settings
function* checkForAddingToBadgeCount({ payload }) {
  const { activeDepartment, showLauncher, defaultTeam } = yield select(getWidgetInfo)

  // do not do anything if messeage is from me or it is manually set not to be counted in badge increment
  if (payload.message.me || payload.noBadgeCount) return

  const teamId = payload.teamId === 'all' || !payload.teamId ? defaultTeam?._id : payload.teamId

  const isUserInActiveDepartment = showLauncher && activeDepartment === teamId
  const isPageHidden = document.hidden

  if (isUserInActiveDepartment && !isPageHidden) {
    yield put(setNotSeenReceivedMsgs({ [teamId]: 0 }))
  } else if (!isUserInActiveDepartment || isPageHidden) {
    yield put(incrementNotSeenReceivedMsgs(teamId))
  }
}

function* talkWithOperatorInsteadOfBot({ payload }) {
  try {
    const texts = yield select(getTexts)
    const { teamId, ...data } = payload
    const response = yield handleTalkWithOperator(socket, data)

    if (response.success) {
      yield put(
        setNewMessage({
          message: {
            type: 'text',
            me: false,
            isAiBotMsg: true,
            hideConnectWithOperatorBtn: true,
            content: texts.waitAgentToAccept,
            createdAt: new Date(),
          },
          teamId,
        }),
      )

      yield put(removeAcceptedChat(teamId))
    }
  } catch (error) {
    console.log(error)
    // Sentry.captureMessage(error, 'error')
  }
}

function* sendSentCloseButtonAction({ payload }) {
  const { value } = payload
  const { acceptedChat, activeDepartment } = yield select(getWidgetInfo)
  const acceptedChatInfo = acceptedChat[activeDepartment]
  const response = yield call(handleSendSentCloseButtonAction, {
    socket,
    conversationId: acceptedChatInfo.agentInfo.conversationId,
    value,
    containerId,
    userId: userIdForSpa,
  })

  if (response.success) {
    yield put(setSentCloseButton({ data: { value: false }, teamId: activeDepartment }))
  }
}

function* write() {
  // while (true) {
  yield takeLatest(messageTypes.SEND_MESSAGE, sendTextMessage)
  yield takeLatest(messageTypes.SEND_FILE_MESSAGE, sendFileMessage)
  yield takeLatest(messageTypes.UPLOAD_FILE, uploadFileMessage)
  yield takeLatest(messageTypes.SEND_DYNAMIC_FORM_MESSAGE, sendDynamicFormMessage)
  yield takeLatest(messageTypes.TYPE_NEW_WORD, sendNewTypedWord)
  yield takeLatest(messageTypes.FETCH_MORE_MESSAGES_START, fetchMoreMessages)
  yield takeLatest(messageTypes.SUBMIT_FEEDBACK, submitFeedback)
  yield takeLatest(messageTypes.REMOVE_CONVERSATION_NOT_SEEN_START, removeConversationNotSeen)
  yield takeLatest(messageTypes.TALK_WITH_OPERATOR_INSTEAD_OF_BOT, talkWithOperatorInsteadOfBot)
  yield takeLatest(messageTypes.RECORD_ROADMAP_CHECKPOINT, recordRoadmapCheckpoints)
  yield takeLatest(messageTypes.SEND_SENT_CLOSE_BUTTON_ACTION, sendSentCloseButtonAction)

  // sendTextMessage(socket, message);
  // sendFileMessage(socket, file);
  // }
}

function* handleIO(socket) {
  yield fork(read, socket)
  yield fork(write, socket)
}

/**
 * show form message and the message that is sent with it in widget
 *
 * @param {string} message -  message that should get displayed before form
 * @param {string} formTitle - form title
 * @param {object[]} formFields - form fields
 *
 **/
function* dispatchFormAndMessageInWidget({ payload }) {
  const { message, formTitle, formFields, formId, shouldDisableInput, teamId, showMessage, notSendToServer, formName } =
    payload

  const { user } = yield select(getWidgetInfo)
  // covering empty formFields to show only message. returned data is not consistent so many cases should be checked
  const areFormFieldsValid = formFields && Object.values(formFields).length !== 0

  // checks if there is atleast one unfilled value in the form
  const anyUnfilledField = areFormFieldsValid && isThereAnyUnfilledFieldInForm(user, formFields)

  const isMessageEmpty = !message || message === '<p></p>'
  // do not dispatch anything if showing message is not explicitly set and also there is not any unfilled field
  if (!anyUnfilledField && !showMessage) return

  if (!isMessageEmpty) {
    yield put(
      setNewMessage({
        message: {
          me: false,
          type: 'text',
          formId,
          content: message,
          isAutoMessage: true,
          createdAt: new Date(),
        },
        teamId,
      }),
    )
  }

  if (areFormFieldsValid) {
    yield put(
      setNewMessage({
        message: {
          me: false,
          formId,
          title: formTitle,
          type: 'dynamicForm',
          fields: formFields,
          isAutoMessage: false,
          createdAt: new Date(),
          formStatus: !anyUnfilledField ? 'filled' : 'unfilled',
          fillingFormIsForced: shouldDisableInput,
          notSendToServer,
          formName,
        },
        teamId,
      }),
    )
  }

  if (shouldDisableInput && anyUnfilledField) {
    yield disableInput()
    // do not show greeting input if there is one unfilled forced form in the row
    yield put(setShowGreetingInput(false))
  }
}

function* dispatchBotMessagesToTeams(widgetResponse, teamIds) {
  const botsData = widgetResponse.data?.responseBotData

  // if no specific bot is set for a teamId then the default bot is set for them
  const defaultBot = botsData.find((item) => !item.teamId)
  const teamsChatInputShouldHideIn = []

  for (let id of teamIds) {
    const botForTeam = botsData?.find((item) => item.teamId === id) || defaultBot

    if (!botForTeam) continue

    yield put(
      setNewMessage({
        message: {
          type: 'bot_message',
          botId: botForTeam.id,
          botMessageLevel: '',
          me: false,
          tmpId: new Date().getTime(),
          sendAfterForm: botForTeam.sendAfterForm,
        },
        teamId: id,
      }),
    )

    // disable chat for hiding chat input and only displaying bot and form messages
    if (botForTeam.disableChat) teamsChatInputShouldHideIn.push(id)
  }

  if (teamsChatInputShouldHideIn.length > 0) {
    yield put(setHideChatInputForTeams(teamsChatInputShouldHideIn))
  }
}

/**
 * send form message according to forms status and takes actions like disabling input
 *
 * @param {boolean} beforeFirstMsgForms - to send forms with beforeSendMessage parameter true
 *
 **/
function* takeFormsAction(noMessageSentBefore) {
  const { isOfficeHour, forms } = yield select(getWidgetInfo)

  // choose form according to being in office hour
  const formType = isOfficeHour ? 'officeHours' : 'notOfficeHours'

  const formObject = forms?.[formType] || {}
  const isFormActive = formObject.active
  const formFields = formObject.forms || []
  const formTitle = formObject.title || ''

  // if user has not sent any message before, then form will be sent initially if `beforeSendMessage` is true
  const doesFirstMessageConditionApply = noMessageSentBefore ? formObject.beforSendMessage : true

  const doNotShowForm = !isFormActive || !doesFirstMessageConditionApply || formObject.sent

  if (doNotShowForm) return

  yield call(dispatchFormAndMessageInWidget, {
    payload: {
      message: formObject.message,
      formTitle,
      formFields,
      formId: formObject.id,
      shouldDisableInput: formObject.isForce,
      teamId: 'all',
      formName: formType,
    },
  })

  // change form status to sent. to remember that this form was sent once for the user
  const newForms = {
    ...forms,
    [formType]: { ...forms[formType], sent: true },
  }

  yield put(setForms(newForms))
}

function* flow() {
  let widgetResponse = yield call(fetchWidgetInfo)

  if (widgetResponse?.status) {
    socket = yield call(connect)
    window.socket = socket
    widgetInfo = widgetResponse.data
    const departments = widgetInfo.teams

    const channel_id = widgetResponse.data.channel.id
    const container_id = widgetResponse.data.channel.containerId
    const forms = widgetResponse.data.forms
    const officeHours = widgetResponse.data.officeHours
    const notOfficeHours = widgetResponse.data.notOfficeHours
    const operators = widgetInfo.operators

    yield put(setDepartments(departments))

    let { acceptedChat, isOfficeHour } = yield select(getWidgetInfo)

    containerId = container_id
    channelId = channel_id

    appLocalStorageObject.init(container_id)

    setTimeout(() => {
      checkForVisitorDetails(socket, channel_id, container_id)
    }, 2000)

    const response = yield call(checkForNewVisitor, {
      socket,
      channel_id,
      container_id,
      forms,
      isOfficeHour,
      officeHours,
      notOfficeHours,
      operators,
    })

    // userId to use sending as query parameter for recording roadmap in spa pages
    userIdForSpa = response.rayToken

    let adaptedMessage = response.messages
    const notSeenReceivedMsgsByTeam = {}

    if (response?.openConversations.length > 0) {
      // separate messages by conv Id
      const messagesGroupedByConvId = groupBy(adaptedMessage, 'conversationId')

      response?.openConversations.forEach((oc) => {
        const notSeenWidget = oc.meta.notSeenWidget
        const notSeenWebappCount = oc.meta.notSeenWebApp
        const conversationId = oc.conversationId
        const teamId = oc.teamId

        notSeenReceivedMsgsByTeam[teamId] = notSeenWebappCount || 0

        // set seen status for all messages
        if (notSeenWidget === 0) {
          messagesGroupedByConvId[conversationId] = messagesGroupedByConvId[conversationId].map((msg) => {
            msg.status = 'seen'
            return msg
          })
        }
        // separate sent and seen messages
        else {
          messagesGroupedByConvId[conversationId] = messagesGroupedByConvId[conversationId].map((msg, index) => {
            if (index < messagesGroupedByConvId[conversationId].length - notSeenWidget) msg.status = 'seen'
            else msg.status = 'sent'
            return msg
          })
        }
      })

      // set 1 tick for other remaining messages
      Object.keys(messagesGroupedByConvId).forEach((k) => {
        messagesGroupedByConvId[k] = messagesGroupedByConvId[k].map((msg) => {
          if (msg.status) return msg

          msg.status = 'sent'
          return msg
        })
      })

      adaptedMessage = [].concat(...Object.values(messagesGroupedByConvId))
    } else {
      // when the current conversation is not accepted yet, set 1 tick for all the sent messages.
      adaptedMessage = response.messages.map((msg) => {
        msg.status = 'sent'
        return msg
      })
    }

    let defaultOnlineAgent = widgetInfo.operators.find((op) => op.online) || widgetInfo.operators[0]
    if (defaultOnlineAgent) {
      yield put(setDefaultOnlineAgent(defaultOnlineAgent))
    }
    yield put(setCurrentUser(response.user))

    // hide widget in none-office hours if is set
    if (widgetInfo.notOfficeHour?.hideWidget === 'true') {
      yield put(setShowWidget(false))
    }

    if (response.messages && Array.isArray(response.messages)) {
      // put every new message into its related team
      for (let message of adaptedMessage) {
        // message.status = "sent"
        yield put(
          setNewMessage({
            message,
            teamId: message.teamId,
            noBadgeCount: true,
          }),
        )
      }
    }

    const noMessageSentBefore = !response.messages.length
    yield takeFormsAction(noMessageSentBefore)
    yield put(setNotSeenReceivedMsgs(notSeenReceivedMsgsByTeam))

    // eslint-disable-next-line eqeqeq
    if (response.forceGetUserDetails == true) {
      yield disableInput()
    }

    if (response.openConversations.length > 0) {
      for (let openConversation of response.openConversations) {
        const agent = {
          name: openConversation.name,
          title: openConversation.title,
          avatar: openConversation.avatar,
          conversationId: openConversation.conversationId,
          id: openConversation.id,
        }

        acceptedChat = {
          status: true,
          agentInfo: agent,
          teamId: openConversation.teamId,
          meta: openConversation.meta,
        }
        yield put(setAcceptedChat(acceptedChat))
      }
    }

    const teamIds = departments?.map((item) => item._id)

    // disable chat in none-office hour if set in settings
    if (widgetResponse.data.notOfficeHours.disableChat && !isOfficeHour) {
      yield put(setHideChatInputForTeams(teamIds))
    }
    yield dispatchBotMessagesToTeams(widgetResponse, teamIds)

    yield put(setWidgetReady())

    yield fork(handleIO, socket)
  }
}

function* disableInput() {
  const { languageInfo } = yield select(getWidgetInfo)

  yield put(
    setDisableInput({
      status: true,
      description: languageInfo.texts.pleaseFillForm,
    }),
  )
}

function* onDispatchFormAndMessage() {
  yield takeLatest(messageTypes.DISPATCH_FORM_AND_MESSAGE, dispatchFormAndMessageInWidget)
}

function* onSetNewMsg() {
  yield takeLatest(messageTypes.SET_NEW_MESSAGE, checkForAddingToBadgeCount)
}

function* onRestartFlowOperation() {
  yield takeLatest(messageTypes.RESTART_FLOW_OPERATION, flow)
}

function* userDidConfirmTheUploadedData({ payload: uploadData }) {
  const { teamId } = uploadData

  try {
    yield put(setConfirmUploadedData(null))
    const response = yield uploadFileMessage(uploadData)

    const sendMediaResp = yield sendMedia({
      fileId: response.responseId,
      type: +response.type,
      tmpId: response.tmpId,
      moreData: response.moreData,
      socket: response.socket,
      token: response.token,
      teamId: response.teamId,
      replyId: response.replyId,
    })

    if (sendMediaResp.tmpId) {
      let t = { status: 'sent', message_id: sendMediaResp.tmpId, team_id: teamId }
      yield put(setMessageStatus(t))

      // check for sending form action after sending message successfully
      yield takeFormsAction(false)
    }

    if (sendMediaResp.status === 400 && sendMediaResp.message === 'required form fields') {
      yield takeFormsAction(false)
    }

    yield put(
      setMessageId({
        prevId: sendMediaResp.tmpId,
        newId: sendMediaResp.chat.id,
        teamId: teamId,
      }),
    )
    yield put(setReplyingMessage(null))
    yield put(setSentCloseButton({ data: { value: false }, teamId }))
  } catch (e) {
    console.log(e)
    // Sentry.captureMessage(e, 'error')
  }
}

function* watchUserDidConfirmTheUploadedData() {
  yield takeEvery(messageTypes.SET_USER_DID_CONFIRM_THE_UPLOADED_DATA, userDidConfirmTheUploadedData)
}

export default function* messageSagas() {
  yield all([
    call(flow),
    call(onDispatchFormAndMessage),
    call(onSetNewMsg),
    call(onRestartFlowOperation),
    call(watchUserDidConfirmTheUploadedData),
  ])
}
